export class GTM {
    static load(config, callback = () => { }) {
        const gtmScript = document.createElement('script');
        gtmScript.type = 'text/javascript';
        gtmScript.innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl+'';f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer', '${config.GTM_ID}')`;
        document.body.appendChild(gtmScript);
        callback();
    }
    static send(data) {
        return new Promise((resolve, reject) => {
            if (!window['google_tag_manager']) {
                console.error('Hey! GTM not found');
            }
            window.dataLayer.push({
                ...data,
                eventCallback: function () {
                    resolve();
                },
                eventTimeout: 2000,
            });
        });
    }
}
